module.exports = __webpack_public_path__ + "img/cartao_maestro.1502b072.png";